var initializer = (function() {
	return function (gantt) {
		return {

			getVerticalScrollbar: function(){
				return gantt.$ui.getView("scrollVer");
			},
			getHorizontalScrollbar: function(){
				return gantt.$ui.getView("scrollHor");
			},

			_legacyGridResizerClass: function(layout){
				var resizers = layout.getCellsByType("resizer");
				for(var i = 0; i < resizers.length; i++){
					var r = resizers[i];
					var prev = r.$parent.getPrevSibling(r.$id);
					if(prev && prev.$config && prev.$config.id === "grid"){
						r.$config.css = (r.$config.css ? r.$config.css + " " : "") + "gantt_grid_resize_wrap";
					}
				}
			},

			onCreated: function (layout) {
				var first = true;

				this._legacyGridResizerClass(layout);

				layout.attachEvent("onBeforeResize", function(){
					var mainTimeline = gantt.$ui.getView("timeline");
					mainTimeline.$config.hidden = mainTimeline.$parent.$config.hidden = !gantt.config.show_chart;

					var mainGrid = gantt.$ui.getView("grid");
					var showGrid = gantt.config.show_grid;
					if(first) {
						var colsWidth = mainGrid._getColsTotalWidth();
						if(colsWidth !== false){
							gantt.config.grid_width = colsWidth;
						}
						showGrid = showGrid && !!gantt.config.grid_width;
						gantt.config.show_grid = showGrid;
					}
					mainGrid.$config.hidden = mainGrid.$parent.$config.hidden = !showGrid;

					if(!mainGrid.$config.hidden){
						mainGrid.$config.width = gantt.config.grid_width - 1;
						if(!first){
							mainGrid.$parent._setContentSize(mainGrid.$config.width, mainGrid.$config.height);
						}else{
							mainGrid.$parent.$config.width = gantt.config.grid_width;
						}
					}

					first = false;

				});

				gantt._getVerticalScrollbar = this.getVerticalScrollbar;
				gantt._getHorizontalScrollbar = this.getHorizontalScrollbar;

				var vertical = this.getVerticalScrollbar();
				var horizontal = this.getHorizontalScrollbar();
				if(vertical){
					vertical.attachEvent("onScroll", function(oldPos, newPos, dir){
						var scrollState = gantt.getScrollState();
						gantt.callEvent("onGanttScroll", [scrollState.x, oldPos, scrollState.x, newPos]);
					});
				}
				if(horizontal){
					horizontal.attachEvent("onScroll", function(oldPos, newPos, dir){
						var scrollState = gantt.getScrollState();
						gantt.callEvent("onGanttScroll", [oldPos, scrollState.y, newPos, scrollState.y]);
					});
				}

				layout.attachEvent("onResize", function(){
					if(vertical && !gantt.$scroll_ver){
						gantt.$scroll_ver = vertical.$scroll_ver;
					}

					if(horizontal && !gantt.$scroll_hor){
						gantt.$scroll_hor = horizontal.$scroll_hor;
					}
				});

			},
			onInitialized: function (layout) {
				var grid = gantt.$ui.getView("grid");
				if(!(grid.$parent && grid.$parent.$parent && grid.$parent.$parent._xLayout)){
					return;
				}

				var parent = grid.$parent.$parent;

				var next = parent.getNextSibling(grid.$parent.$id);

				// expose grid resize events
				if(next && next.$name == "resizer"){
					var initialWidth;
					next.attachEvent("onResizeStart", function(prevCellWidth, nextCellWidth){

						var grid = gantt.$ui.getView("grid");
						var viewCell = grid ? grid.$parent : null;
						if(viewCell){
							var minWidth = 0;
							var cols = gantt.getGridColumns();
							for(var i = 0; i < cols.length; i++){
								minWidth += cols[i].min_width ? cols[i].min_width : gantt.config.min_grid_column_width;
							}

							viewCell.$config.minWidth = minWidth;
						}
						initialWidth = prevCellWidth;
						return gantt.callEvent("onGridResizeStart", [prevCellWidth]);
					});
					next.attachEvent("onResize", function(newBehindSize, newFrontSize){
						return gantt.callEvent("onGridResize", [initialWidth, newBehindSize]);
					});
					next.attachEvent("onResizeEnd", function(oldBackSize, oldFrontSize, newBackSize, newFrontSize){

						var grid = gantt.$ui.getView("grid");
						var viewCell = grid ? grid.$parent : null;
						if(viewCell){
							viewCell.$config.minWidth = undefined;
						}
						var res = gantt.callEvent("onGridResizeEnd", [oldBackSize, newBackSize]);
						if(res){
							gantt.config.grid_width = newBackSize;
						}

						return res;
					});
				}

			},
			onDestroyed: function (timeline) {

			}
		};
	};
})();

module.exports = initializer;


//////////////////
// WEBPACK FOOTER
// ./sources/core/ui/main_layout_initializer.js
// module id = 50
// module chunks = 0